<template>
  <cleave :id="uid" v-model="val" class="form-control" :options="formats[type]" :disabled="disabled" />
</template>

<script>
  import Vue from 'vue';
  import Cleave from 'vue-cleave-component';
  import 'cleave.js/dist/addons/cleave-phone.us';

  const formats = {
    phone: {
      phone: true,
      phoneRegionCode: 'US',
      delimiter: '-',
    },
    money: {
      prefix: '$ ',
      numeral: true,
      numeralPositiveOnly: true,
      noImmediatePrefix: true,
      rawValueTrimPrefix: true,
      numeralIntegerScale: 3,
      numeralDecimalScale: 2
    },
    percent: {
      prefix: '% ',
      numeral: true,
      numeralPositiveOnly: true,
      noImmediatePrefix: true,
      rawValueTrimPrefix: true,
      numeralIntegerScale: 3,
      numeralDecimalScale: 2
    },
  };

  export default Vue.extend({
    components: {
      Cleave,
    },

    props: {
      id: {
        type: String,
        default: ''
      },
      value: {
        type: [String, Number],
        default: ''
      },
      disabled: {
        type: Boolean,
        default: false
      },
      type: {
        type: String,
        default: 'phone',
        validator: function (value) {
          return Object.prototype.hasOwnProperty.call(formats, value);
        }
      }
    },

    data: () => ({
      uid: '',
      val: '',
      formats: formats
    }),

    created() {
      this.uid = this.id ? this.id : this._uid;
      this.val = this.value;
    },

    watch: {
      id(val) {
        this.uid = val;
      },

      value(val) {
        this.val = val;
      },

      val(val) {
        if (this.type == "percent" && val > 100)
          val = 100;

        this.$emit('input', val);
        this.$emit('change', val);
      }
    }
  });
</script>